import React, { useState, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import 'tui-grid/dist/tui-grid.css';
import Grid from '@toast-ui/react-grid';
// import 'tui-pagination/dist/tui-pagination.css';
import '../Shared/Css/Watch.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Button from '@material-ui/core/Button';
import { AccountBoxRounded } from '@material-ui/icons';

function Watch() {
  const [dataApi, setDataApi] = useState([]); // 데이타 저장하기
  const [newday, setNewday] = useState(''); //날짜
  const [newtime, setNewtime] = useState(''); //시간
  const [timecount, setTimecount] = useState(1); //time 카운트

  dayjs.locale('ko');
  //히스토리사용
  const history = useHistory();

  const getJsonLoadApi = useCallback(async () => {
    const url =
      'http://apis.data.go.kr/1360000/VilageFcstInfoService_2.0/getUltraSrtNcst';
    await axios
      .get(url, {
        params: {
          serviceKey:
            'N8bTPeqggrYZOL+7VhNrXw5oPSVjPbUxc8KSr1wAqFqnUTxJSY44ThDbadyxHnDE2ZcLQBHxXfLeFmdX3kZ+Ag==',
          pageNo: 1,
          numOfRows: 1000,
          dataType: 'json',
          base_date: `${newday}`,
          base_time: `${newtime}`,
          nx: 89,
          ny: 91,
        },
      })
      .then((res) => {
        let Ary = res.data.response.body.items.item;
        //console.log(Ary);
        for (var i = 0; i < Ary.length; i++) {
          Ary.splice(4, 4); //삭제하는것은 삭제시작인덱스로 시작하여 몇개를 삭제할것인가
          switch (Ary[i].category) {
            case 'T1H':
              let copy01 = [...Ary];
              copy01[i].category = '온도';
              setDataApi(copy01);
              break;
            case 'RN1':
              let copy02 = [...Ary];
              copy02[i].category = '강수량';
              setDataApi(copy02);
              break;
            case 'SKY':
              let copy03 = [...Ary];
              copy03[i].category = '하늘상태';
              setDataApi(copy03);
              break;
            case 'UUU':
              let copy04 = [...Ary];
              copy04[i].category = '동서바람';
              setDataApi(copy04);
              break;
            case 'VVV':
              let copy05 = [...Ary];
              copy05[i].category = '남북바람';
              setDataApi(copy05);
              break;
            case 'REH':
              let copy06 = [...Ary];
              copy06[i].category = '습도';
              setDataApi(copy06);
              break;
            case 'PTY':
              let copy07 = [...Ary];
              copy07[i].category = '강수형태';
              setDataApi(copy07);
              break;
            case 'LGT':
              let copy08 = [...Ary];
              copy08[i].category = '낙뢰';
              setDataApi(copy08);
              break;
            case 'VEC':
              let copy09 = [...Ary];
              copy09[i].category = '풍량';
              setDataApi(copy09);
              break;
            case 'WSD':
              let copy10 = [...Ary];
              copy10[i].category = '풍속';
              setDataApi(copy10);
              break;
            default:
              break;
          }
          //예보내용
          switch (Ary[i].category) {
            case '강수형태':
              let copy01 = [...Ary];
              if (
                copy01[i].category === '강수형태' &&
                copy01[i].obsrValue === '0'
              ) {
                copy01[i].obsrValue = '비없음';
              } else if (
                copy01[i].category === '강수형태' &&
                copy01[i].obsrValue === '1'
              ) {
                copy01[i].obsrValue = '비';
              } else if (
                copy01[i].category === '강수형태' &&
                copy01[i].obsrValue === '2'
              ) {
                copy01[i].obsrValue = '비/눈';
              } else if (
                copy01[i].category === '강수형태' &&
                copy01[i].obsrValue === '3'
              ) {
                copy01[i].obsrValue = '눈';
              } else if (
                copy01[i].category === '강수형태' &&
                copy01[i].obsrValue === '4'
              ) {
                copy01[i].obsrValue = '소나기';
              } else if (
                copy01[i].category === '강수형태' &&
                copy01[i].obsrValue === '5'
              ) {
                copy01[i].obsrValue = '빗방울';
              } else if (
                copy01[i].category === '강수형태' &&
                copy01[i].obsrValue === '6'
              ) {
                copy01[i].obsrValue = '빗방울눈날림';
              } else if (
                copy01[i].category === '강수형태' &&
                copy01[i].obsrValue === '7'
              ) {
                copy01[i].obsrValue = '눈날림';
              }
              setDataApi(copy01);
              break;
            default:
              break;
          }
          //습도
          switch (Ary[i].category) {
            case '습도':
              let copy01 = [...Ary];
              if (copy01[i].category === '습도') {
                copy01[i].obsrValue += '%';
              }
              setDataApi(copy01);
              break;
            default:
              break;
          }
          //강수량
          switch (Ary[i].category) {
            case '강수량':
              let copy01 = [...Ary];
              if (copy01[i].category === '강수량') {
                copy01[i].obsrValue += 'mm';
              }
              setDataApi(copy01);
              break;
            default:
              break;
          }
          //강수량
          switch (Ary[i].category) {
            case '온도':
              let copy01 = [...Ary];
              if (copy01[i].category === '온도') {
                // copy01[i].obsrValue += '℃';
                copy01[i].obsrValue += '';
              }
              setDataApi(copy01);
              break;
            default:
              break;
          }
        }
      })
      .catch((error) => {
        //console.log('axios 통신실패')
        //console.log(error.response);
      });
  }, [newday, newtime]);

  const nowdata = () => {
    setNewday(dayjs(new Date()).format('YYYYMMDD').toString());
    if (
      dayjs(new Date()).format('HH') - 1 < 10 &&
      (dayjs(new Date()).format('HH') - 1).toString().length === 1
    ) {
      setNewtime('0' + (dayjs(new Date()).format('HH') - 1).toString() + '00');
    } else {
      setNewtime((dayjs(new Date()).format('HH') - 1).toString() + '00');
    }
  };

  useEffect(() => {
    nowdata();
    getJsonLoadApi();
    //console.log('Watch천번째재랜드링됨')
  }, [getJsonLoadApi]);

  useEffect(() => {
    // 설정된 시간 간격마다 setInterval 콜백이 실행된다.
    const id = setInterval(() => {
      setTimecount((timecount) => timecount - 1);
    }, 30000);

    // 0이 되면 카운트가 멈춤
    if (timecount === 0) {
      nowdata();
      getJsonLoadApi();
      clearInterval(id);
      setTimecount(1);
      //console.log('Watch두번째재랜드링됨')
    }
    return () => {
      clearInterval(id);
    };
  }, [getJsonLoadApi, timecount, newtime]);

  // console.log(dataApi)

  //console.log(newday);
  //console.log(newtime);
  //new Grid option 설정부분
  const columns = [
    {
      name: 'baseDate',
      header: '발표일자',
      align: 'center',
      width: 130,
      className: 'baseDateFont',
    },
    { name: 'baseTime', header: '발표시간', align: 'center', width: 120 },
    { name: 'category', header: '예보항목', align: 'left', width: 150 },
    { name: 'obsrValue', header: '예보', align: 'left', width: 150 },
  ];

  const rows = dataApi.map((row, ii) => ({
    baseDate: row.baseDate + 0 === row.baseDate + ii ? row.baseDate : null,
    baseTime:
      row.baseDate + 0 === row.baseDate + ii
        ? dayjs(dayjs(row.baseTime, 'HHmm').toDate()).format('Ahh') + '시'
        : null,
    category: row.category,
    obsrValue:
      row.baseTime === '0600' ||
      row.baseTime === '0700' ||
      row.baseTime === '0800' ||
      row.baseTime === '0900' ||
      row.baseTime === '1000' ||
      row.baseTime === '1100' ||
      row.baseTime === '1200' ||
      row.baseTime === '1300' ||
      row.baseTime === '1400' ||
      row.baseTime === '1500' ||
      row.baseTime === '1600' ||
      row.baseTime === '1700' ||
      row.baseTime === '1800' ||
      row.baseTime === '1900'
        ? row.obsrValue === '비없음'
          ? `<i class="fas fa-sun" style="font-size:22px;color:#DB4455;"></i><em style="font-size:16px;color:black;">${row.obsrValue}</em> `
          : row.obsrValue === '비'
          ? `<i class="fa-sharp fa-solid fa-umbrella" style="font-size:20px;color:#006666;"></i> ${row.obsrValue}`
          : row.obsrValue === '비/눈'
          ? `<i class="fa-sharp fa-solid fa-umbrella" style="font-size:20px;color:#006666;"></i>${row.obsrValue}`
          : row.obsrValue === '눈'
          ? `<i class="fas fa-snowman" style="font-size:24px;color:#006666;"></i> ${row.obsrValue}`
          : row.obsrValue === '소나기'
          ? `<i class="fa-solid fa-cloud-showers-heavy" style="font-size:20px;color:#3399CC;"></i> ${row.obsrValue}`
          : row.category === '습도'
          ? `<em style="font-size:20px;color:#3399CC;">${row.obsrValue}</em>`
          : row.category === '강수량'
          ? `<em style="font-size:20px;color:#3399CC;">${row.obsrValue}</em>`
          : row.category === '온도'
          ? row.obsrValue <= -6
            ? `<em style="font-size:20px;color:#e91e63">${row.obsrValue}℃ 동파경계</em>`
            : row.obsrValue <= -4
            ? `<em style="font-size:20px;color:#f6685e">${row.obsrValue}℃ 동파주의</em>`
            : row.obsrValue <= 26
            ? `<em style="font-size:20px;color:#2979ff">${row.obsrValue}℃</em>`
            : row.obsrValue <= 30
            ? `<em style="font-size:20px;color:#2979ff">${row.obsrValue}℃</em>`
            : row.obsrValue <= 32
            ? `<em style="font-size:20px;color:#ff6333">${row.obsrValue}℃</em>`
            : row.obsrValue >= 33
            ? `<em style="font-size:20px;color:#ff3d00">${row.obsrValue}℃</em>`
            : null
          : null
        : row.obsrValue === '비없음'
        ? `<i class="fa-solid fa-moon" style="font-size:20px;color:#ffc107;"></i> ${row.obsrValue} `
        : row.obsrValue === '비'
        ? `<i class="fa-sharp fa-solid fa-umbrella" style="font-size:20px;color:#757575;"></i> ${row.obsrValue}`
        : row.obsrValue === '비/눈'
        ? `<i class="fa-sharp fa-solid fa-umbrella" style="font-size:20px;color:#006666;"></i>${row.obsrValue}`
        : row.obsrValue === '눈'
        ? `<i class="fas fa-snowman" style="font-size:24px;color:#006666;"></i> ${row.obsrValue}`
        : row.obsrValue === '소나기'
        ? `<i class="fa-solid fa-cloud-showers-heavy" style="font-size:20px;color:#757575;"></i> ${row.obsrValue}`
        : row.category === '습도'
        ? row.obsrValue
        : row.category === '온도'
        ? row.obsrValue <= -6
          ? `<em style="font-size:20px;color:#e91e63">${row.obsrValue}℃ 동파경계</em>`
          : row.obsrValue <= -4
          ? `<em style="font-size:20px;color:#f6685e">${row.obsrValue}℃ 동파주의</em>`
          : row.obsrValue <= 26
          ? `<em style="font-size:20px;color:#2979ff">${row.obsrValue}℃</em>`
          : row.obsrValue <= 30
          ? `<em style="font-size:20px;color:#2979ff">${row.obsrValue}℃</em>`
          : row.obsrValue <= 32
          ? `<em style="font-size:20px;color:#ff6333">${row.obsrValue}℃</em>`
          : row.obsrValue >= 33
          ? `<em style="font-size:20px;color:#ff3d00">${row.obsrValue}℃</em>`
          : null
        : null,
  }));

  //한글 및 테마설정--정적api 문서 확이해서 적용할것.
  const Gr = require('tui-grid');
  Gr.setLanguage('ko');
  Gr.applyTheme('striped', {
    cell: {
      header: {
        background: '#DCDCDC',
        border: '#C0C0C0',
        text: 'blue',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
    },

    //호버설정
    row: {
      hover: {
        background: 'silver',
      },
    },
  });
  return (
    <div>
      <h3 style={{ textAlign: 'center' }}>실시간날씨정보</h3>
      <Container maxWidth="sm">
        <Box style={{ marginTop: '10px' }}>
          <Grid
            columns={columns}
            data={rows}
            scrollY={false}
            scrollX={false}
            usageStatistics={false} //전 세계적으로 TOAST UI Grid가 얼마나 널리 사용되고 있는지 파악 사용
          />
        </Box>
        <br></br>
        <Button
          variant="contained"
          style={{
            background: '#689f38',
            color: 'white',
            fontSize: '14px',
            height: 30,
            width: 150,
            float: 'center',
          }}
          onClick={() => {
            history.push('/WatchApi/WatchYebo');
          }}
        >
          <i
            className="fa-solid fa-umbrella"
            style={{ fontSize: '16px', color: '#2979ff' }}
          ></i>
          [3]일 날씨예보
        </Button>
      </Container>
    </div>
  );
}

export default Watch;
